export default {
  brandColor1: '#C12C2E',
  complimentaryColor1: '#f0ede5',
  brandColor2: '#211E1E',
  complimentaryColor2: '#f0ede5',
};
